import { IAboutPage } from '../components/types'
import { about_element } from '../__generated__/about'
import { getPropDescriptionsByCode, getPropValuesByCode } from './gql'

export const createAboutContent = (element: about_element): IAboutPage => {
  const values = getPropValuesByCode(element?.propertyValues, 'HTML')
  const descriptions = getPropDescriptionsByCode(
    element?.propertyValues,
    'HTML',
  )
  const contents = values?.map((value, index) => ({
    code: descriptions[index],
    contents: value,
  }))

  return {
    code: element?.code,
    contents,
  }
}
